import React, { useCallback, useEffect, useState } from "react";

import { useBreakpoint } from "../../hooks/useBreakpoint";
import ContentCard from "../cards/contentCard";
import { ConditionalSwiper } from "../shared/conditionalSwiper";
import { Paginator } from "../shared/paginator";

const TextCardList = ({
  articleList,
  conditionalSliderOpts = {},
  showPagination = true,
  initialVisibleCount = 4,
  mobileVisibleCount = 4,
  containerClass = "w-full flex justify-center bg-generic-bg planet:bg-gray-standard",
  innerContainerClass = "relative w-11/12 md:w-9/12 mx-auto pt-20 pb-[148px] md:pb-44 bg-inherit",
  gridContainerClass = "relative grid grid-cols-1 md:grid-cols-2 gap-x-20 gap-y-5 md:gap-y-11",
  paginationBtnContainerClass = "mt-16",
  cardBoxCoverClass = "sm:gvi-program-card-box bg-transparent",
  headerTitleContainerClass = "pb-4 flex flex-row items-center border-b border-gray-lighter justify-between text-black-lighter planet:text-gray-generic"
}) => {
  const [visibleCnt, setVisibleCnt] = useState(initialVisibleCount);
  const [pagination, setPagination] = useState(showPagination);
  const breakpoint = useBreakpoint();

  useEffect(() => {
    setVisibleCnt(
      breakpoint === "xs" ? mobileVisibleCount : initialVisibleCount
    );
  }, [breakpoint, initialVisibleCount, mobileVisibleCount]);

  useEffect(() => {
    if (visibleCnt >= articleList?.length) setPagination(false);
  }, [articleList?.length, visibleCnt]);

  const handlePagination = useCallback(() => {
    setVisibleCnt((prevState) => prevState + 4);
  }, []);

  return (
    <>
      {articleList && articleList.length > 0 && (
        <section className={`text-card-container ${containerClass}`}>
          <div className={`text-card-list ${innerContainerClass}`}>
            <Paginator
              pagination={pagination}
              paginationCallback={handlePagination}
              paginatorContainerClass=""
              paginationBtnContainerClass={paginationBtnContainerClass}
            >
              <div className={gridContainerClass}>
                <ConditionalSwiper {...conditionalSliderOpts}>
                  {articleList?.slice(0, visibleCnt)?.map((cardData, index) => (
                    <ContentCard
                      {...cardData}
                      key={index}
                      title={cardData?.title}
                      subtitle={cardData?.subtitle}
                      description={cardData?.description}
                      imgUrl={
                        breakpoint === "xs"
                          ? cardData?.imgMobileUrl || cardData?.imgUrl
                          : cardData?.imgUrl
                      }
                      imgHeight={cardData?.imgHeight ?? "h-44"}
                      url={cardData?.url}
                      linkTitle={cardData?.linkTitle}
                      externalLink={cardData.externalLink}
                      type={3}
                      innerContainerFullheight={true}
                      cardBoxCoverClass={cardBoxCoverClass}
                      headerTitleContainerClass={headerTitleContainerClass}
                    />
                  ))}
                </ConditionalSwiper>
              </div>
            </Paginator>
          </div>
        </section>
      )}
    </>
  );
};

export default TextCardList;
